import { useCallback, useMemo, useState } from 'react'
import { RecoverPasswordContext } from './RecoverPasswordContext'
import { sendCodeAsync } from '@/services/axios/guest/authenticate'
import { sweetError } from '@/utils/sweetalert2'
import { AUTHENTICATED, RECOVERY_PASSWORD, TOKEN } from '@/utils/constants'
import Cookies from 'js-cookie'
import { encrypt } from '@/utils'
import { validateCodeAsync } from '@/services/axios/authenticated/recover'
import { useRouter } from 'next/router'

export const RecoverPasswordProvider = ({ children }) => {
  const [step, setStep] = useState(1)
  const router = useRouter()
  const nextStep = useCallback(
    () => {
      setStep(step + 1)
    },
    [step]
  )

  const onSubmit = useMemo(() => {
    const handleSendCode = (data) => {
      sendCodeAsync(data)
        .then((response) => {
          const { data: { token: { access_token: accessToken } } } = response
          Cookies.set(AUTHENTICATED, encrypt(RECOVERY_PASSWORD))
          Cookies.set(TOKEN, encrypt(accessToken))
          nextStep()
        }).catch((e) => {
          sweetError('', e)
        })
    }
    const handleVerifyCode = (data) => {
      const formData = {
        code: `${data.codeone}${data.codetwo}${data.codethree}${data.codefour}${data.codefive}`
      }
      validateCodeAsync(formData)
        .then((response) => {
          const { data: { token: { access_token: accessToken } } } = response
          Cookies.set(AUTHENTICATED, encrypt(RECOVERY_PASSWORD))
          Cookies.set(TOKEN, encrypt(accessToken))
          nextStep()
        }).catch((e) => {
          sweetError('', e)
        })
    }
    // const handleChangePassword = (data) => {
    //   changePasswordAsync(data)
    //     .then((response) => {
    //       const { data: { token: { access_token: accessToken } } } = response
    //       Cookies.set(AUTHENTICATED, encrypt(RECOVERY_PASSWORD))
    //       Cookies.set(TOKEN, encrypt(accessToken))
    //       // Cookies.remove(AUTHENTICATED)
    //       // Cookies.remove(TOKEN)
    //       router.push('/system/dashboard')
    //       // nextStep()
    //     }).catch((e) => {
    //       sweetError('', e)
    //     })
    // }
    return {
      handleSendCode,
      handleVerifyCode
      // handleChangePassword
    }
  }, [nextStep, router])

  const onClick = useMemo(() => {
    const handleGoBack = () => {
      Cookies.remove(AUTHENTICATED)
      Cookies.remove(TOKEN)
      setStep(1)
      router.push('/login/recover-password')
    }
    return {
      handleGoBack
    }
  }, [router])

  const valueMemo = useMemo(() => ({
    step,
    onSubmit,
    onClick
  }), [onClick, onSubmit, step])
  return (
    <RecoverPasswordContext.Provider value={valueMemo}>
      {children}
    </RecoverPasswordContext.Provider>
  )
}
